import { useMemo } from 'react';
import { localizationService } from '@shared-services/localization-service';

const useBookingMarkupData = () => {
    const date = useMemo(() => {
        const today = new Date();
        return {
            year: today.getFullYear(),
            month: today.toLocaleString('default', { month: 'long' }),
            day: today.getDate(),
            dayInWeek: today.toLocaleString('default', { weekday: 'short' }),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    }, []);

    const mockInfo = {
        userName: localizationService.str(
            'ui.runtimessr.calbooking.markup.userName'
        ),
        eventName: localizationService.str(
            'ui.runtimessr.calbooking.markup.eventType'
        ),
        data: [
            {
                value: '30m',
                icon: '⏱',
            },
            {
                value: 'Online Meeting',
                icon: '🗓️',
            },
            {
                value: date.timeZone,
                icon: '🌐',
            },
        ],
    };

    return {
        date,
        mockInfo,
    };
};

export default useBookingMarkupData;
